var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { InfoModalComponent } from "app/views/modal/info_modal.component";
import * as moment from 'moment-timezone';
var PaidDetailsComponent = /** @class */ (function (_super) {
    __extends(PaidDetailsComponent, _super);
    function PaidDetailsComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.moment = moment;
        _this.detailLoader = false;
        return _this;
    }
    PaidDetailsComponent.prototype.ok = function () {
        this.close();
    };
    return PaidDetailsComponent;
}(InfoModalComponent));
export { PaidDetailsComponent };
